'use client';
import Image from 'next/image';
import StarRating from '@/components/common/StarRating/StarRating';

import { SetStateAction, useEffect, useState } from 'react';
import { Button, Flex, Heading } from 'politicamente-informados-ds';
import {
  FeedbackWrapper,
  FeedbackContainer,
  CollapsibleHeader,
  CollapseIcon,
  CollapsibleContent,
  StyledContentIntro,
  StyledQuestions,
  StyledQuestion,
  Success,
  Error,
} from './Feedback.theme';
import { feedbackPost } from '@/lib/chat/FeedbackActions';

export default function Feedback() {
  const [selectedImagesRating, setSelectedImagesRating] = useState<number>(0);
  const [selectedWrittenContentRating, setSelectedWrittenContentRating] =
    useState<number>(0);
  const [selectedVisualsSupportRating, setSelectedVisualsSupportRating] =
    useState<number>(0);
  const [selectedEducatedRating, setSelectedEducatedRating] =
    useState<number>(0);
  const [message, setMessage] = useState<string>('');

  const [collapsed, setCollapsed] = useState<boolean>(true);
  const [submittedFeedback, setSubmittedFeedback] = useState<boolean>(false);
  const [sending, setSending] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);

  const [alreadyAnswered, setAlreadyAnswered] = useState<boolean>(false);

  const validateIfAllFields = () => {
    return (
      selectedImagesRating > 0 &&
      selectedWrittenContentRating > 0 &&
      selectedVisualsSupportRating > 0 &&
      selectedEducatedRating > 0
    );
  };

  const submitFeedbackHandler = async () => {
    const form = {
      selectedImagesRating,
      selectedWrittenContentRating,
      selectedVisualsSupportRating,
      selectedEducatedRating,
      message,
    };
    setSending(true);
    setError(false);

    try {
      const response = await feedbackPost(form);

      if (!response.success) {
        throw response.error;
      }

      setSending(false);
      setSubmittedFeedback(true);
    } catch (error) {
      setSending(false);
      setError(true);
      console.error('Error:', error);
    }
  };

  const handleChange = (event: {
    target: { value: SetStateAction<string> };
  }) => {
    setMessage(event.target.value);
  };

  useEffect(() => {
    if (submittedFeedback) {
      const timeout = setTimeout(() => {
        setAlreadyAnswered(true);
      }, 4000);
      return () => clearTimeout(timeout);
    }
  }, [submittedFeedback === true]);
  return (
    <FeedbackWrapper $hidden={alreadyAnswered}>
      <FeedbackContainer collapsed={collapsed}>
        {!error ? (
          <>
            {!submittedFeedback ? (
              <div>
                <CollapsibleHeader onClick={() => setCollapsed(!collapsed)}>
                  <Heading
                    size='texts'
                    tag='h3'
                    className='fw-semibold'
                  >
                    Olá 👋
                  </Heading>
                  <CollapseIcon
                    collapsed={collapsed}
                    xmlns='http://www.w3.org/2000/svg'
                    width='15'
                    height='15'
                    fill='none'
                    viewBox='0 0 24 24'
                    stroke='currentColor'
                    strokeWidth={2}
                  >
                    <path
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      d='M19 9l-7 7-7-7'
                    />
                  </CollapseIcon>
                </CollapsibleHeader>
                <CollapsibleContent collapsed={collapsed}>
                  <StyledContentIntro>
                    <Heading
                      tag='p'
                      size='captions'
                      className='fw-semibold'
                    >
                      Como avalias os seguintes pontos do Politicamente
                      Informados:
                    </Heading>
                  </StyledContentIntro>
                  <StyledQuestions data-lenis-prevent={true} >
                    <StyledQuestion>
                      <Heading
                        size='captions'
                        tag='p'
                        className='fw-semibold'
                      >
                        Imagem do site
                      </Heading>
                      <StarRating
                        initialRating={selectedImagesRating}
                        onRatingChange={(rating: number) =>
                          setSelectedImagesRating(rating)
                        }
                      />
                    </StyledQuestion>
                    <StyledQuestion>
                      <Heading
                        size='captions'
                        tag='p'
                        className='fw-semibold'
                      >
                        Conteúdo escrito
                      </Heading>

                      <StarRating
                        initialRating={selectedWrittenContentRating}
                        onRatingChange={(rating: number) =>
                          setSelectedWrittenContentRating(rating)
                        }
                      />
                    </StyledQuestion>

                    <StyledQuestion>
                      <Heading
                        size='captions'
                        tag='p'
                        className='fw-semibold'
                      >
                        Suportes visuais (vídeos, imagens)
                      </Heading>

                      <StarRating
                        initialRating={selectedVisualsSupportRating}
                        onRatingChange={(rating: number) =>
                          setSelectedVisualsSupportRating(rating)
                        }
                      />
                    </StyledQuestion>
                    <StyledQuestion>
                      <Heading
                        size='captions'
                        tag='p'
                        className='fw-semibold text-center'
                      >
                        Ficaste mais esclarecido sobre o tema depois de acederes
                        ao site?
                      </Heading>

                      <StarRating
                        initialRating={selectedEducatedRating}
                        onRatingChange={(rating: number) =>
                          setSelectedEducatedRating(rating)
                        }
                      />
                    </StyledQuestion>
                    <StyledQuestion>
                      <label>
                        <Heading
                          style={{ marginBottom: '10px' }}
                          size='captions'
                          tag='p'
                          className='fw-semibold text-center'
                        >
                          Deixa-nos a tua opinião ou sugestão:
                        </Heading>
                        <textarea
                          rows={2}
                          cols={40}
                          value={message}
                          onChange={handleChange}
                          placeholder='Deixa-nos a tua opinião ou sugestão'
                          style={{ width: '100%' }}
                        />
                      </label>
                    </StyledQuestion>

                    <Flex justify='center' align='center'>
                        <Button
                          disabled={!validateIfAllFields()}
                          variant='primary'
                          onClick={submitFeedbackHandler}
                        >
                          <Heading size='captions'>
                            {!sending ? 'Enviar' : 'Enviando...'}
                          </Heading>
                        </Button>
                    </Flex>
                  </StyledQuestions>
                </CollapsibleContent>
              </div>
            ) : (
              <Success>
                <Image
                  src='/assets/success.gif'
                  width='100'
                  height='100'
                  alt='success'
                />
                <Heading tag='h3' size='h3' style={{textAlign: 'center'}} className='fw-semibold'>
                  Obrigado pelo seu feedback.
                </Heading>
              </Success>
            )}
          </>
        ) : (
          <Error>
            <h3>Um erro ocorreu.</h3>
            <Button
              onClick={() => {
                setError(false);
              }}
            >
              Repetir
            </Button>
          </Error>
        )}
      </FeedbackContainer>
    </FeedbackWrapper>
  );
}
